import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { ConfirmDialogModel, ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';




@Component({
    selector: 'app-nav',
    templateUrl: 'nav.component.html',
    styleUrls: ['./nav.component.scss'],


})
export class NavComponent implements OnInit {
    isAuthenticated$: Observable<boolean> | undefined;



    constructor(public oidcSecurityService: OidcSecurityService, public dialog: MatDialog) { }



    ngOnInit() {
        this.isAuthenticated$ = this.oidcSecurityService.isAuthenticated$;
    }


    login() {
        this.oidcSecurityService.authorize();
    }

    refreshSession() {
        this.oidcSecurityService.authorize();
    }

    logout() {
        this.oidcSecurityService.logoff();
    }

    confirmDialog(): void {


        const dialogData = new ConfirmDialogModel("Logout");

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: "300px",
            height: "180px",
            data: dialogData
        });


    }

}

